import React from "react";
import { PiLock } from "react-icons/pi";
import InfoBanner from "./InfoBanner.tsx";
import { getRenewalAction, Lapse } from "../utils/checkout.ts";

// Shown on pages someone can still open after their access has ended
const ReadOnlyBanner = ({ lapse }: { lapse: Lapse }) => {
  const renewal = getRenewalAction(lapse);

  return (
    <InfoBanner
      icon={<PiLock size={24} />}
      color="blue"
      ctaText={renewal.text}
      onCtaClick={() => {
        window.location.href = renewal.url;
      }}
    >
      <p>
        {lapse.reason === "payment_failed"
          ? "Your account is read-only until your payment goes through."
          : "Your account is read-only."}{" "}
        You can still view and download your receipts.
      </p>
    </InfoBanner>
  );
};

export default ReadOnlyBanner;
